<template>
  <div>
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      first-number
      last-number
      class="mb-0 mt-1 mt-sm-0"
      prev-class="prev-item"
      next-class="next-item"
    >
      <template #prev-text>
        <feather-icon
          icon="ChevronLeftIcon"
          size="18"
        />
      </template>

      <template #next-text>
        <feather-icon
          icon="ChevronRightIcon"
          size="18"
        />
      </template>
    </b-pagination>
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue'

export default {
  name: 'Pagination',
  components: {
    BPagination,
  },
  props: {
    perPage: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    hasValue() {
      return !!this.currentPage
    },
  },
  watch: {
    currentPage(value) {
      this.$emit('input', value)
    },
  },
  created() {
    if (this.value) {
      this.currentPage = this.value
    }
  },
}
</script>

<style>
.pagination .page-item .page-link:hover {
  color: var(--primary) !important;
}

.pagination .prev-item .page-link:hover,
.pagination .next-item .page-link:hover {
  background-color: var(--primary) !important;
  color: black !important;
}

.dark-layout .pagination .prev-item .page-link:hover,
.dark-layout .pagination .next-item .page-link:hover {
  background-color: var(--primary) !important;
  color: white !important;
}
</style>
